import type { DiscountCode } from "@graphql/generated/types";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";

export const useGetHeaders = () => {
    const { getMultiple, get: getMicrocopy } = useMicrocopy();

    const microcopies = (() => {
        return getMultiple(CommonCMS.page, [
            CommonCMS.promoCode.title,
            CommonCMS.promoCode.apply,
            CommonCMS.promoCode.error,
            CommonCMS.promoCode.remove,
            CommonCMS.promoCode.removeAria,
            CommonCMS.promoCode.applyAria,
            CommonCMS.promoCode.discountApplied,
            CommonCMS.promoCode.discountCodeNoEffect,
        ]);
    })();

    const headers = {
        title: microcopies[CommonCMS.promoCode.title],
        apply: microcopies[CommonCMS.promoCode.apply],
        error: microcopies[CommonCMS.promoCode.error],
        remove: microcopies[CommonCMS.promoCode.remove],
        removeAria: microcopies[CommonCMS.promoCode.removeAria],
        applyAria: microcopies[CommonCMS.promoCode.applyAria],
        discountApplied: microcopies[CommonCMS.promoCode.discountApplied],
        discountCodeNoEffect: microcopies[CommonCMS.promoCode.discountCodeNoEffect],
    };

    const getLocalError = (discountCode: DiscountCode, countryISOCode: string) =>
        getMicrocopy(CommonCMS.page, "PromoNoMatch", {
            replacements: {
                voucherName:
                    discountCode?.name || discountCode?.code?.substring(countryISOCode.length),
            },
        });

    const getDiscountCodeNoEffectMessage = (discountCode: DiscountCode, countryISOCode: string) =>
        getMicrocopy(CommonCMS.page, CommonCMS.promoCode.discountCodeNoEffect, {
            replacements: {
                voucherName:
                    discountCode?.name || discountCode?.code?.substring(countryISOCode.length),
            },
        });

    return { headers, getLocalError, getDiscountCodeNoEffectMessage };
};
